import NotFoundPage from 'views/notfound/NotFoundPage'

export default NotFoundPage
